class MobileSearchBar {
    constructor (theme, elem) {
        this._elem = elem
        this._bar = null
    }

    onInit () {
        this._bar = document.querySelector('.mobile-search-bar')
        if (this._bar) {
            this._elem.addEventListener('click', (e) => {
                e.preventDefault()
                this.toggleSearch()
            })
        }
    }

    toggleSearch () {
        this._bar.classList.toggle('mobile-search-bar--open')
    }
}

export default MobileSearchBar



// WEBPACK FOOTER //
// ./src/resources/scripts/components/MobileSearchBar.js